<template>
<div class="public-layout-wrapper">
  <public-layout-header />
  <!-- <breadcrumb v-if="show"></breadcrumb> -->
  <public-layout-main />
  <public-layout-footer />
  <div class="fixleft">
      <el-backtop
        target=".public-layout-wrapper"
        :visibility-height="30"
      ></el-backtop>
      <!-- <div class="appdown"></div> -->
      <div class="gotop" :title="$t('layout2.PublicLayout.259576-0')" ref="gotop"></div>
    </div>
</div>

</template>

<script>
import PublicLayoutMain from './PublicLayoutMain'
import PublicLayoutHeader from './PublicLayoutHeader'
import PublicLayoutFooter from './PublicLayoutFooter'
import ResizeMixin from '@/framework/layout/mixin/ResizeHandler'
import Breadcrumb from '@/framework/components/Breadcrumb'
import { mapState } from 'vuex'

export default {
  name: 'PublicLayout',
  components: {
    PublicLayoutMain,
    PublicLayoutHeader,
    PublicLayoutFooter,
    Breadcrumb
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      noticeNumber: state => state.app.noticeNumber,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader,
      show: state=>state.settings.breadcrumbShow,
      userId: state=>state.user.userId
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  mounted() {
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/framework/styles/mixin.scss";
  @import "~@/config/styles/variables.scss";
  .public-layout-wrapper {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    height: auto;
    min-height: 750px;
    overflow-x: hidden;
    .main {
      flex: 1;
    }
  }
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }

    .hamburger-container {
      line-height: $tabsHeight;
      height: 100%;
      float: left;
      cursor: pointer;
      transition: background .3s;
      -webkit-tap-highlight-color:transparent;
      border-width: 0px;

      &:hover {
        background: rgba(0, 0, 0, .025)
      }
    }
    .app-main-scroll-container {
      height: calc(100vh - #{$tabsHeight} - #{$headerHeight});
      width: 100%;
      .scrollbar {
        height: 100%;
        .scrollbar-wrapper {
          overflow-x: hidden;
        }
      }
    }
    .footer {
      height: $footerHeight;
      background: $footerBackgroundColor;
      color: $footerFontColor;
      font-size: $footerFontSize;
      text-align: $footerAlign;
      width: 100%;
      line-height: $footerHeight;
      border-top: 1px solid $footerBorderColor;
    }
  }



  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
